import { InjectionToken } from '@angular/core';

export const FORBIDDEN_ROUTE = new InjectionToken<() => string>(
    'FORBIDDEN_ROUTE'
);
